import { cx } from "../cx";

export function Switch({
  checked,
  onChange,
  label,
}: {
  checked: boolean;
  onChange: (value: boolean) => void;
  label: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => {
        onChange(!checked);
      }}
      className="inline-flex h-7 items-center gap-2 rounded-lg border border-border bg-bg px-2.5 text-md text-fg hover:bg-surface-2"
    >
      <span className={cx("relative h-4 w-7 rounded-full transition-colors", checked ? "bg-link" : "bg-surface-3")}>
        <span
          className={cx(
            "absolute top-0.5 size-3 rounded-full bg-bg shadow-sm transition-[left]",
            checked ? "left-[14px]" : "left-0.5",
          )}
        />
      </span>
      {label}
    </button>
  );
}
